import { convertToQueryString } from 'app/shared/functions';
import { HttpClient } from 'app/library/client';
import { IListFilter, ResponseBase, ResponseContentBase, ResponseListBase } from "app/shared";
import { ActivityEntity, ISubscriber } from './types';
import { getEndpoint } from 'app/utils/service';
import { api } from 'app/utils/api';

export class ActivityService {

    /** It gets all Activity. */
    async getActivities(options: IListFilter): Promise<ResponseBase<ResponseListBase<ActivityEntity[]>>> {
        return HttpClient.getClient().get(getEndpoint('/activity/search') + `?${convertToQueryString(options)}`);
    }

    /** It get spesific Activity by Activity id */
    async getActivity(id: string, language: string): Promise<ResponseBase<ResponseContentBase<ActivityEntity>>> {
        return HttpClient.getClient().get(getEndpoint('/activity/') + id + `?language=${language || "en"}`);
    }

    /** It creates Activity by request */
    async createActivity(request: ActivityEntity): Promise<ResponseBase<ResponseContentBase<ActivityEntity>>> {
        return HttpClient.getClient().post(getEndpoint('/activity/'), request);
    }

    /** It updates spesific Activity by id */
    async updateActivity(request: ActivityEntity): Promise<ResponseBase<boolean>> {
        return HttpClient.getClient().patch(getEndpoint('/activity/') + request.id, request);
    }

    /** It deletes spesific Activity by id */
    async deleteActivity(id: string): Promise<ResponseBase<boolean>> {
        return HttpClient.getClient().delete(getEndpoint('/activity/') + id);
    }

    async getSubscriberEmails(activtyId: string):Promise<ResponseBase<ResponseListBase<ISubscriber[]>>> {
        return HttpClient.getClient().get(getEndpoint(api.prefixes.activityFeedback.emails) + `?activityId=${activtyId}&page=1&pageSize=1000&descending=false`);
    }

    async getSubscriberEmailsTotal(activtyId: string):Promise<ResponseBase<ResponseListBase<ISubscriber[]>>> {
        return HttpClient.getClient().get(getEndpoint(api.prefixes.activityFeedback.emails) + `?activityId=${activtyId}&page=1&pageSize=1000&descending=false&isDeleted=true`);
    }

    /** It can change featured field. */
    async toogleFeaturedActivity(id: string, isFeaturedActivity: boolean, key:string, lang:string): Promise<ResponseBase<boolean>> {
        return HttpClient.getClient().patch(
          getEndpoint(`/activity/featured-activity/${id}`),
          { isFeaturedActivity: !isFeaturedActivity, key, language: lang }
        );
    }

    async getFeaturedActivities(options: IListFilter): Promise<ResponseBase<ResponseListBase<ActivityEntity[]>>> {
        return HttpClient.getClient().get(getEndpoint('/activity/search-featured-activity') + `?${convertToQueryString(options)}`);
    }

}
